angular.module('webremote.dashboard').controller('widget_levelmeterTextual',
  function ($scope, objectManagerService) {
    $scope.om = objectManagerService
  })
